import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';
import { Params } from 'express-serve-static-core';
import { DsChipColorVariant } from '@levelaccess/design-system';
import { BaseCellComponent, ICellConfig, IIconConfig, ITagConfig, setupCell } from '../base-cell/base-cell.component';

export interface ILinkCellConfig extends ICellConfig, ITagConfig {
  icon?: IIconConfig;
  tagLabel?: string;
  tagColorVariant?: DsChipColorVariant;
  noDecoration?: boolean;
  linkLabel?: string;
}

@Component({
  selector: 'table-cell-link',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    <ng-template #icon>
      <svg
        [class.me-2]="config.icon.iconBeforeText"
        [class.ms-2]="!config.icon.iconBeforeText"
        [attr.aria-hidden]="!config.icon.iconAriaLabelText"
        [attr.aria-label]="config.icon.iconAriaLabelText"
        [attr.width]="config.icon.iconWidth"
        [attr.height]="config.icon.iconHeight"
        [ngStyle]="config.icon.iconStyles"
        #svgTemplate
      >
        <use [attr.xlink:href]="'#' + config.icon.iconName"></use>
      </svg>
    </ng-template>
    <div [ngStyle]="config.wrapperStyles">
      <a
        [routerLink]="routerLink"
        [queryParams]="queryParams"
        [fragment]="fragment"
        [ngStyle]="config?.styles"
        [queryParamsHandling]="queryParamsHandling"
        [state]="state"
        [class.margin-right]="config.tagLabel"
        [attr.aria-label]="config.linkLabel"
        (click)="onClick($event)"
        #ref
      >
        @if (config.icon && config.icon.iconBeforeText) {
          <ng-template [ngTemplateOutlet]="icon"></ng-template>
        }
        <span [ngClass]="{ 'text-underline': !config.noDecoration }">{{ config.text }}</span>
        @if (config.icon && !config.icon.iconBeforeText) {
          <ng-template [ngTemplateOutlet]="icon"></ng-template>
        }
      </a>
      @if (config.tagLabel) {
        <ds-chip
          class="tag-label"
          data-test-id="table-cell-tag-label"
          role="button"
          [text]="config.tagLabel"
          [colorVariant]="config.tagColorVariant"
          [size]="'small'"
          [appTooltip]="config.tagTooltip"
          [attr.aria-label]="config.tagTooltip"
        ></ds-chip>
      }
      @if (config.subText) {
        <div class="sub-text" data-test-id="table-cell-sub-text">
          {{ config.subText }}
        </div>
      }
    </div>
  `,
})
export class LinkCellComponent extends BaseCellComponent implements OnInit, AfterViewInit {
  @ViewChild('svgTemplate')
  public svgElement: ElementRef;

  @Input() public config: ILinkCellConfig;
  public routerLink: string;
  public queryParams: Params;
  public fragment: string;
  public queryParamsHandling: QueryParamsHandling;
  public state: { [k: string]: any };

  public onClick(event: MouseEvent): void {
    event?.stopPropagation();
  }

  public ngOnInit(): void {
    this.routerLink = this.config.attributes['href'] || this.config.attributes['routerLink'];
    this.queryParams = this.config.attributes['queryParams'] || {};
    this.fragment = this.config.attributes['fragment'] || null;
    this.queryParamsHandling = this.config.attributes['queryParamsHandling'] || '';
    this.state = this.config.attributes['state'];
  }

  public ngAfterViewInit(): void {
    if (this.config.icon !== undefined) {
      setupCell(this.renderer, this.config.icon, this.svgElement.nativeElement);
    }

    super.ngAfterViewInit();
  }
}
